import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { StepsMap } from '../Routes';
import { useParams } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function WizardMobileHeader() {
  const {
    step
  } = useParams();
  const stepIndex = StepsMap.indexOf(`/${step}`);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingInline: "1100",
    paddingBlockStart: "500",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.wizard.heading"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.wizard.stepCounter",
      options: {
        current: stepIndex + 1,
        total: StepsMap.length
      }
    })]
  });
}